<template>
    <div class="page">
        <query-form :form="form" ref="queryForm" @dateChange="dateChange" />
        <search-bar :ordersPrice="ordersPrice" :count="count" />
        <el-table :data="payBillList" style="width: 100%" header-row-class-name="table-header">
            <el-table-column v-for="item of tableHead" :key="item.prop" :label="item.label" :width="item.width || 'auto'">
                <template slot-scope="{row}">
                    <template v-if="item.prop">
                        <span v-if="item.prop==='status'">
                            <span>{{ row.status | getTypeStatus }}</span>
                        </span>
                        <span v-else-if="item.prop==='tradeChannel'">
                            <span>{{ row.tradeChannel | getTradeChannel }}</span>
                        </span>
                        <span v-else>{{ row[item.prop] }}</span>
                    </template>
                    <template v-else>
                        <div class="btn-container">
                            <span class="btn" @click="refundInfo(row)">查看退款单</span>
                            <span class="btn" v-if="row.dealAmount>row.refundAmount" @click="applyRefund(row)">申请退款</span>
                        </div>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <Pagination :params="form" @changeSize="changeSize" @changePage="changePage" />
        </div>
    </div>
</template>

<script>
import { refundState, channelList, typeList } from '@trading/static/data.js';
import { mapActions, mapState } from 'vuex';
import queryForm from '@trading/components/query-form.vue';
import searchBar from '@trading/components/search-bar.vue';
export default {
  name: 'refundList',
  computed: {
    ...mapState({
      payBillList: (state) => state.trading.payBillList,
      ordersPrice: (state) => state.trading.ordersPrice,
      count: (state) => state.trading.count,
      total: (state) => state.trading.total,
    }),
  },
  filters: {
    getTradeChannel(code) {
      return channelList.get(code);
    },
    getTypeStatus(code) {
      return typeList.get(code);
    },
  },
  provide() {
    return {
      submit: this.queryTableInfo,
      formList: refundState.query_form_list,
      tradTime: refundState.tradTime,
      searchList: this.getSearchList,
      searchPlaceholder: refundState.searchPlaceholder,
      downLoadExcel: this.downLoadExcel,
      rightList: refundState.rightList,
      resetForm: this.resetForm,
    };
  },
  components: {
    queryForm,
    searchBar,
  },
  data() {
    return {
      tableHead: refundState.tableHead,
      form: {
        timeType: null, // 1:支付时间2:交易时间 3:提交时间4:完成时间
        startTime: '', //开始时间
        endTime: '', //结束时间
        payChannel: '', //支付渠道 微信/支付宝/汇付宝/银联
        payType: '', //支付类型:JSAPI JSGZHAPI MICROPAY F2FPAY APP等等
        mchCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode, //商户Code
        payStatus: 9, //0未知，1待支付，2支付中，3已支付，4支付失败，5退款中，6已退款，7退款失败,8已支付(含退款),9退款全部状态
        outTradeNo: '', //订单号
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      searchVal: null, //搜索
    };
  },
  async created() {
    await this.queryPayBill(this.form);
    this.form.total = this.total;
  },
  methods: {
    ...mapActions('trading', ['queryPayBill']),
    // 申请退款
    async applyRefund(row) {
      console.log(row);
      this.$router.push({ name: 'trading/applyRefund', query: { id: row.id } });
    },
    // 修改条数
    changeSize(val) {
      this.form.pageSize = val;
      this.queryPayBill(this.form);
    },
    // 修改页数
    changePage(val) {
      this.form.pageNum = val;
      this.queryPayBill(this.form);
    },
    // 条件查询
    async queryTableInfo(form) {
      Object.assign(this.form, form);
      await this.queryPayBill(this.form);
      this.form.total = this.total;
    },
    // 搜索
    async getSearchList(item) {
      this.form.outTradeNo = item;
      await this.queryPayBill(this.form);
      this.form.total = this.total;
    },
    // 导出excel
    downLoadExcel() {},
    //重置
    async resetForm() {
      this.form = {
        timeType: null, // 1:支付时间2:交易时间 3:提交时间4:完成时间
        startTime: '', //开始时间
        endTime: '', //结束时间
        payChannel: '', //支付渠道 微信/支付宝/汇付宝/银联
        payType: '', //支付类型:JSAPI JSGZHAPI MICROPAY F2FPAY APP等等
        mchCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode, //商户Code
        payStatus: 9, //0未知（支付全部状态），1待支付，2支付中，3已支付，4支付失败，5退款中，6已退款，7退款失败,8已支付(含退款)
        outTradeNo: '', //订单号
        pageNum: 1,
        pageSize: 10,
        total: 0,
      };
      this.$refs.queryForm.clearDate();
      await this.queryPayBill(this.form);
      this.form.total = this.total;
    },
    //日期改变
    dateChange(e) {
      this.form.startTime = e[0];
      this.form.endTime = e[1];
    },
    refundInfo(row) {
      this.$router.push({ path: 'refund/detail', query: { id: row.id } });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@reconciliation/static/common.less';
/deep/.error {
  color: #ff5f5f;
}
</style>
